<div class="protected-layout-container">
    <app-header></app-header>

    <main class="protected-layout-content">
        <router-outlet></router-outlet>
    </main>

    <app-footer></app-footer>
</div>